export const LEGACY_THEME_CLASS = 'legacy-theme';
